import React, { memo } from 'react';

import { Block } from '../../components/core';
import { SensitivityAnalysisContent } from './sensitivity-analysis-content';
import { SensitivityAnalysisHeader } from './sensitivity-analysis-header';

import { COMMON_ERROR_WRAPPERS } from '../../../studio-blocks/components/error-wrappers/common';
import { MetricsErrorWrapper } from '../../../studio-blocks/components/error-wrappers/MetricsErrorWrapper';

interface SensitivityAnalysisBlockProps {
  id: string;
}

export const SensitivityAnalysisBlock = memo(function InternalSensitivityAnalysisBlock({
  id,
}: SensitivityAnalysisBlockProps) {
  return (
    <Block.Root id={id}>
      <Block.Header>
        <SensitivityAnalysisHeader id={id} />
      </Block.Header>

      <Block.Content id={id} errorWrappers={[...COMMON_ERROR_WRAPPERS, MetricsErrorWrapper]}>
        <SensitivityAnalysisContent id={id} />
      </Block.Content>
    </Block.Root>
  );
});
